const TeachersTypes = {
  SET_TEACHERS_LOADING: 'TEACHERS/SET_TEACHERS_LOADING',
  SET_TEACHERS_FAILURE: 'TEACHERS/SET_TEACHERS_FAILURE',
  SET_TEACHERS_SUCCESS: 'TEACHERS/SET_TEACHERS_SUCCESS',
};

export default TeachersTypes;